import React from 'react';
import {
  FilledButton,
  FlexRow,
  SvgIcon,
  Text,
  useTextFormatter
} from '@make-software/tg-mini-app-ui';

import NoFriendsBanner from '@/shared/assets/logos/no-friends-banner.png';
import GoldIcon from '@/shared/assets/icons/gold.svg';

import { Banner, ButtonWrapper, Content, NoFriendsWrapper, SubTitle, Title } from './styled';

export interface NoFriendsProps {
  onInvite: () => void;
}

export const NoFriends: React.FC<NoFriendsProps> = ({ onInvite }) => {
  const formatter = useTextFormatter();

  const handleInviteNow = () => {
    onInvite?.();
  };

  return (
    <NoFriendsWrapper justify={'center'} align={'center'}>
      <Banner src={NoFriendsBanner} alt="NoFriendsBanner" />
      <Content gap={14} direction={'column'}>
        <Title weight={3} size={'lg'} color="#FFFFFF">
          No friends invited
        </Title>
        <FlexRow gap={6} align={'center'}>
          <SubTitle>Invite a friend and get</SubTitle>
          <SvgIcon src={GoldIcon} />
          <Text weight={1} size={'lg'} monotype color="#FFFFFF">
            {formatter.formatPoints(parseInt(window.config.season_info.friendship_reward, 10))}
          </Text>
        </FlexRow>
      </Content>
      <ButtonWrapper>
        <FilledButton
          title={'Invite Now'}
          onClick={handleInviteNow}
          fontFamily="Inter"
          fontWeight="400"
        />
      </ButtonWrapper>
    </NoFriendsWrapper>
  );
};
